import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { ApiCenter } from '../../api/ApiCenter';
import { Button, Form, Radio, Space } from 'antd';
import classes from './style.css/Attestation.module.css';
// interface Theme {
//   id: number;
//   category_id: number;
//   title: string;
//   is_visible: boolean;
//   is_draft: boolean;
// }

interface Questions {
  id: number;
  test_id: number;
  text: string;
  answers: {
    id: number;
    question_id: number;
    is_right: boolean;
    text: string;
  }[];
}
interface Quiz {
  category: {
    id: number;
    title: string;
  };
  attestation: Questions[];
}
interface IonFinish {
  id: number;
  answers: number[];
}
interface TestResult {
  success: boolean;
  message: string;
  data: {
    result: {
      id: number;
      user_id: number;
      points: number;
      questions_count: number;
      is_passed: boolean;
      complete_date: string;
    };
  };
}

interface TestResult {
  id: number;
  user_id: number;
  test_id: number;
  points: number;
  questions_count: number;
  is_passed: boolean;
  complete_date: string;
}
const Attestation = () => {
  const { id } = useParams();
  const ApiStart = new ApiCenter();
  const [data, setData] = useState<Quiz>();
  const [form] = Form.useForm();
  const [messageApi, setMessageApi] = useState<TestResult>();
  useEffect(() => {
    ApiStart.GET_API('hr/attestation').then((response) => {
      if (response.success) {
        setData(response.data);
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);
  if (!data) {
    return <>Нет данных</>;
  }
  const onFinish = (value: IonFinish) => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const resultMap = Object.entries(value).map(([key, item]) => {
      return item;
    });
    ApiStart.GET_API(`hr/attestation/solution`, 'POST', resultMap).then((response: TestResult) => {
      if (response.success) {
        setMessageApi(response);
      } else {
        alert(response.message);
      }
    });
  };
  return (
    <>
      <Form form={form} name="Test" onFinish={onFinish} autoComplete="off" layout="vertical">
        <div className={classes.questionsText}>Список вопросов:</div>
        {data?.attestation?.map((item, index: number) => {
          return (
            <div className={classes.WrapperAnswer} key={item.id}>
              <div className={classes.AnswerTitle}>Вопрос {index + 1}.</div>
              <Form.Item
                name={`id+${item.id}`}
                label={<h1>{item?.text}</h1>}
                rules={[{ required: true, message: 'Выберете ответ !' }]}
              >
                <Radio.Group>
                  <Space direction="vertical">
                    {item.answers.map((answer) => {
                      return (
                        <React.Fragment key={answer.id}>
                          <Radio value={{ id: answer.question_id, answers: [answer.id] }}>
                            {answer.text}
                          </Radio>
                        </React.Fragment>
                      );
                    })}
                  </Space>
                </Radio.Group>
              </Form.Item>
            </div>
          );
        })}
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <div style={{ display: 'flex', gap: '10px' }}>
            <div>Результаты теста:</div>
            <div style={{ color: messageApi?.data.result.is_passed ? 'green' : 'red' }}>
              {messageApi?.message} из {messageApi?.data.result?.questions_count}
            </div>
          </div>
          <Form.Item>
            <Button type="default" htmlType="submit">
              Проверить результаты
            </Button>
          </Form.Item>
        </div>
      </Form>
    </>
  );
};

export default Attestation;
